// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <div class="sub-header">
    <h2 class="sub-header__title">{{'Edit ' + \$ctrl.accessRule.displayName + ' for role: ' + \$ctrl.role.name}}</h1>
  </div>

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active">
        <a data-target="#access-rule-configuration" data-toggle="tab">
          <span>
            <i ng-if="accessRuleForm.\$invalid"
               class="icon icon-warning-sign">
            </i>
            Write Access Configuration
          </span>
        </a>
      </li>
      <li ng-if="\$ctrl.executionIsApprovalHierarchy()">
        <a data-target="#approval-hierarchy" data-toggle="tab">
          <span>
            <i ng-if="approvalHierarchyForm.\$invalid"
               class="icon icon-warning-sign">
            </i>
            Approval Hierarchy
          </span>
        </a>
      </li>
    </ul>
  </div>
</div>

<div class="tab-content">

  <div class="tab-pane active" id="access-rule-configuration">

    <form name="accessRuleForm">
      <h2 class="section-header">Access Rule Details</h2>
        <table class="table">
          <tbody class="action-config">
          <tr>
            <td>Action</td>
            <td>
              <input disabled ng-value="\$ctrl.accessRule.displayName">
            </td>
          </tr>

          <tr>
            <td>Execution type</td>
            <td>
              <select ng-options="type.value as type.label for type in \$ctrl.executionTypes"
                      ng-model="\$ctrl.accessRule.executionType"
                      required>
              </select>
            </td>
          </tr>

          <tr>
            <td>Can approve</td>
            <td>
              <select boolean-options
                      required
                      ng-model="\$ctrl.accessRule.approve">
              </select>
            </td>
          </tr>

          <tr ng-if="\$ctrl.accessRule.approve">
            <td>Override type</td>
            <td>
              <multiselect items="\$ctrl.overrideTypes"
                           required
                           ng-model="\$ctrl.accessRule.overrideType">
              </multiselect>
            </td>
          </tr>

          <tr>
            <td>Requires OTP</td>
            <td>
              <select boolean-options
                      required
                      ng-model="\$ctrl.accessRule.otpRequired">
              </select>
            </td>
          </tr>

          <tr>
            <td>Allowed on non-working day:</td>
            <td>
              <select boolean-options
                      required
                      ng-model="\$ctrl.accessRule.allowedOnHoliday">
              </select>
            </td>
          </tr>

          <tr ng-if="\$ctrl.hasAccessRule(\$ctrl.accessRule.command)">
            <td colspan="2">Extra conditions</td>
          </tr>

          <tr ng-repeat="(accessInput, _) in \$ctrl.accessRule.predicates['GREATER_THAN_AMOUNT']"
              ng-if="\$ctrl.isPredicatePresent('GREATER_THAN_AMOUNT')">
            <td>Greater than amount</td>
            <td>
              <amount-predicate predicates="\$ctrl.accessRule.predicates"
                                rule-definitions="\$ctrl.accessRuleDefinition.ruleDefinitions"
                                type="'GREATER_THAN_AMOUNT'"
                                access-input="accessInput"></amount-predicate>
            </td>
          </tr>
          <tr ng-repeat="(accessInput, _) in \$ctrl.accessRule.predicates['GREATER_THAN_OR_EQUAL_AMOUNT']"
              ng-if="\$ctrl.isPredicatePresent('GREATER_THAN_OR_EQUAL_AMOUNT')">
            <td>Greater than or equal amount</td>
            <td>
              <amount-predicate predicates="\$ctrl.accessRule.predicates"
                                rule-definitions="\$ctrl.accessRuleDefinition.ruleDefinitions"
                                type="'GREATER_THAN_OR_EQUAL_AMOUNT'"
                                access-input="accessInput"></amount-predicate>
            </td>
          </tr>

          <tr ng-repeat="(accessInput, _) in \$ctrl.accessRule.predicates['LESS_THAN_AMOUNT']"
              ng-if="\$ctrl.isPredicatePresent('LESS_THAN_AMOUNT')">
            <td>Less than amount</td>
            <td>
              <amount-predicate predicates="\$ctrl.accessRule.predicates"
                                rule-definitions="\$ctrl.accessRuleDefinition.ruleDefinitions"
                                type="'LESS_THAN_AMOUNT'"
                                access-input="accessInput"></amount-predicate>
            </td>
          </tr>

          <tr ng-repeat="(accessInput, _) in \$ctrl.accessRule.predicates['LESS_THAN_OR_EQUAL_AMOUNT']"
              ng-if="\$ctrl.isPredicatePresent('LESS_THAN_OR_EQUAL_AMOUNT')">
            <td>Less than or equal amount</td>
            <td>
              <amount-predicate predicates="\$ctrl.accessRule.predicates"
                                rule-definitions="\$ctrl.accessRuleDefinition.ruleDefinitions"
                                type="'LESS_THAN_OR_EQUAL_AMOUNT'"
                                access-input="accessInput"></amount-predicate>
            </td>
          </tr>

          <tr ng-repeat="(accessInput, _) in \$ctrl.accessRule.predicates['BRANCH_ACCESS_MODE']"
              ng-if="\$ctrl.isPredicatePresent('BRANCH_ACCESS_MODE')">
            <td>Branch restrictions</td>
            <td>
              <mother-branch-predicate type="'BRANCH_ACCESS_MODE'"
                                       predicates="\$ctrl.accessRule.predicates"
                                       rule-definitions="\$ctrl.accessRuleDefinition.ruleDefinitions"
                                       access-input="accessInput"></mother-branch-predicate>
            </td>
          </tr>

          <tr ng-repeat="(accessInput, _) in \$ctrl.accessRule.predicates['USER_ACCESS_MODE']"
              ng-if="\$ctrl.isPredicatePresent('USER_ACCESS_MODE')">
            <td>User restrictions</td>
            <td>
              <user-predicate predicates="\$ctrl.accessRule.predicates"
                              rule-definitions="\$ctrl.accessRuleDefinition.ruleDefinitions"
                              access-input="accessInput"></user-predicate>
            </td>
          </tr>

          <tr ng-repeat="(accessInput, _) in \$ctrl.accessRule.predicates['IN']"
              ng-if="\$ctrl.isPredicatePresent('IN')">
            <td>Allowed values</td>
            <td ng-if="accessInput === 'PRODUCT_STATUS'">
              <product-status-predicate predicates="\$ctrl.accessRule.predicates"
                                        rule-definitions="\$ctrl.accessRuleDefinition.ruleDefinitions"
                                        access-input="accessInput"
                                        type="'IN'">
              </product-status-predicate>
            </td>
            <td ng-if="accessInput === 'PRODUCT_DEFINITION'">
              <product-definition-predicate predicates="\$ctrl.accessRule.predicates"
                                            rule-definitions="\$ctrl.accessRuleDefinition.ruleDefinitions"
                                            access-input="accessInput",
                                            command-group="\$ctrl.commandGroup"
                                            type="'IN'">
              </product-definition-predicate>
            </td>
            <td ng-if="accessInput === 'DEPOSITORY_BANK_ACCESS'">
              <mother-branch-predicate type="'IN'"
                                       predicates="\$ctrl.accessRule.predicates"
                                       rule-definitions="\$ctrl.accessRuleDefinition.ruleDefinitions"
                                       access-input="accessInput"></mother-branch-predicate>
            </td>
            <td ng-if="accessInput === 'PRODUCT_BRANCH_ACCESS'">
              <mother-branch-predicate type="'IN'"
                                       predicates="\$ctrl.accessRule.predicates"
                                       rule-definitions="\$ctrl.accessRuleDefinition.ruleDefinitions"
                                       access-input="accessInput"></mother-branch-predicate>
            </td>
          </tr>

          <tr ng-repeat="(accessInput, _) in \$ctrl.accessRule.predicates['EQUALS']"
              ng-if="\$ctrl.isPredicatePresent('EQUALS')">
            <td>Equals</td>
            <td ng-if="accessInput !== 'AGENT_PAYMENT_MODE'">
              <boolean-predicate type="'EQUALS'"
                                 predicates="\$ctrl.accessRule.predicates"
                                 rule-definitions="\$ctrl.accessRuleDefinition.ruleDefinitions"
                                 access-input="accessInput">
              </boolean-predicate>
            </td>
            <td ng-if="accessInput === 'AGENT_PAYMENT_MODE'">
              <agent-payment-mode-predicate predicates="\$ctrl.accessRule.predicates"
                                            rule-definitions="\$ctrl.accessRuleDefinition.ruleDefinitions"
                                            access-input="accessInput",
                                            type="'EQUALS'">
              </agent-payment-mode-predicate>
            </td>
          </tr>

          <tr class="predicates-row" ng-if="\$ctrl.hasAccessRule(\$ctrl.accessRule.command)">
            <td>Add extra conditions</td>
            <td>
              <div class="predicates-group">

                <div class="btn-group">
                  <button class="btn btn-primary dropdown-toggle"
                          data-toggle="dropdown">
                    Add <span class="caret"></span></button>
                  <ul class="dropdown-menu">
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['GREATER_THAN_AMOUNT']">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'GREATER_THAN_AMOUNT')">Amount greater than</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['GREATER_THAN_OR_EQUAL_AMOUNT']">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'GREATER_THAN_OR_EQUAL_AMOUNT')">Amount greater or
                        equal than</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['LESS_THAN_AMOUNT']">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'LESS_THAN_AMOUNT')">Amount smaller than</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['LESS_THAN_OR_EQUAL_AMOUNT']">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'LESS_THAN_OR_EQUAL_AMOUNT')">Amount smaller or
                        equal
                        than</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['BRANCH_ACCESS_MODE']">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'BRANCH_ACCESS_MODE')">Branch restriction</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['USER_ACCESS_MODE']">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'USER_ACCESS_MODE')">User restriction</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['IN'] && \$ctrl.hasInputDefinition('PRODUCT_STATUS')">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'IN', 'PRODUCT_STATUS')">Status restriction</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['EQUALS'] && \$ctrl.hasInputDefinition('LOAN_CUSTOM_PAYMENT')">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'EQUALS', 'LOAN_CUSTOM_PAYMENT')">Allow custom payment</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['EQUALS'] && \$ctrl.hasInputDefinition('ON_RELEASE_DATE')">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'EQUALS', 'ON_RELEASE_DATE')">Allow only on loan release date</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['IN'] && \$ctrl.hasInputDefinition('DEPOSITORY_BANK_ACCESS')">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'IN', 'DEPOSITORY_BANK_ACCESS')">Allowed depository branch mode</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['EQUALS'] && \$ctrl.hasInputDefinition('APPLICATION_FROM_EXISTING_CIF')">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'EQUALS', 'APPLICATION_FROM_EXISTING_CIF')">Application from existing CIF</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['EQUALS'] && \$ctrl.hasInputDefinition('AGENT_PAYMENT_MODE')">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'EQUALS', 'AGENT_PAYMENT_MODE')">Agent Payment mode</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['EQUALS'] && \$ctrl.hasInputDefinition('FORCED_LOAN_RENEWAL')">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'EQUALS', 'FORCED_LOAN_RENEWAL')">Forced Renewal</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['IN'] && \$ctrl.hasInputDefinition('PRODUCT_DEFINITION')">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'IN', 'PRODUCT_DEFINITION')">Product restriction</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['EQUALS'] && \$ctrl.hasInputDefinition('DOSRI')">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'EQUALS', 'DOSRI')">Dosri Restriction</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['EQUALS'] && \$ctrl.hasInputDefinition('EMPLOYEE')">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'EQUALS', 'EMPLOYEE')">Bank Employee Restriction</a>
                    </li>
                    <li ng-if="\$ctrl.availablePredicates[\$ctrl.accessRule.command]['IN'] && \$ctrl.hasInputDefinition('PRODUCT_BRANCH_ACCESS')">
                      <a ng-click="\$ctrl.addPredicate(\$ctrl.accessRule, 'IN', 'PRODUCT_BRANCH_ACCESS')">Target products branch restriction</a>
                    </li>
                  </ul>
                </div>

              </div>
            </td>
          </tr>

          </tbody>

        </table>
    </form>

  </div>

  <div class="tab-pane" id="approval-hierarchy">
    <ng-form name="approvalHierarchyForm">
      <access-rule-approval-hierarchy
        access-rule="\$ctrl.accessRule"
        approval-hierarchy="\$ctrl.approvalHierarchy">
      </access-rule-approval-hierarchy>
    </ng-form>
  </div>

  <div class="actions flex-end">
    <button type="button"
            class="btn btn-warning"
            ng-click="\$ctrl.navigateBackToGroupedList()">
      Cancel
    </button>
    <button type="button"
            ng-disabled="accessRuleForm.\$invalid || (\$ctrl.executionIsApprovalHierarchy() && approvalHierarchyForm.\$invalid)"
            ng-click="\$ctrl.save()"
            class="btn btn-success">
      Save
    </button>
  </div>
</div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/role-write-access/details/role-write-access-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;